  document.querySelectorAll('.ss[id^="ss-"]').forEach((root) => {
  const form = root.querySelector('[data-ss-form]');
  const qtyInput = root.querySelector('[data-ss-qty]');
  const btnPrice = root.querySelector('[data-ss-btn-price]');
  const stickyPrice = root.querySelector('[data-ss-sticky-price]');
  root.querySelectorAll('.ss-offer input').forEach((input) => {
    input.addEventListener('change', () => {
      root.querySelectorAll('.ss-offer').forEach((o) => o.classList.remove('is-selected'));
      input.closest('.ss-offer').classList.add('is-selected');
      qtyInput.value = input.value;
      if (btnPrice) btnPrice.textContent = input.dataset.price;
      if (stickyPrice) stickyPrice.textContent = input.dataset.price;
      root.querySelectorAll('[data-ss-btn-label], [data-ss-sticky-label]').forEach((el) => { el.textContent = input.dataset.label; });
    });
  });

  const track = root.querySelector('[data-ss-track]');
  const dots = root.querySelectorAll('[data-ss-dots] button');
  if (track && dots.length) {
    dots.forEach((dot) => dot.addEventListener('click', () => {
      track.scrollTo({ left: track.clientWidth * Number(dot.dataset.index), behavior: 'smooth' });
    }));
    const go = (step) => {
      const i = Math.round(track.scrollLeft / track.clientWidth);
      const next = (i + step + dots.length) % dots.length;
      track.scrollTo({ left: track.clientWidth * next, behavior: 'smooth' });
    };
    root.querySelector('[data-ss-prev]')?.addEventListener('click', () => go(-1));
    root.querySelector('[data-ss-next]')?.addEventListener('click', () => go(1));
    track.addEventListener('scroll', () => {
      const i = Math.round(track.scrollLeft / track.clientWidth);
      dots.forEach((d, n) => d.classList.toggle('is-active', n === i));
    }, { passive: true });
  }

  const vrow = root.querySelector('[data-ss-vrow]');
  if (vrow) {
    const step = (dir) => {
      const item = vrow.querySelector('.ss-videos__item');
      const w = item ? item.getBoundingClientRect().width + 12 : 260;
      vrow.scrollBy({ left: dir * w, behavior: 'smooth' });
    };
    root.querySelector('[data-ss-vprev]')?.addEventListener('click', () => step(-1));
    root.querySelector('[data-ss-vnext]')?.addEventListener('click', () => step(1));
  }

  const sticky = root.querySelector('[data-ss-sticky]');
  const submit = root.querySelector('[data-ss-submit]');
  if (sticky && submit && 'IntersectionObserver' in window) {
    new IntersectionObserver(([entry]) => {
      const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
    }).observe(submit);
    root.querySelector('[data-ss-sticky-btn]').addEventListener('click', () => form.requestSubmit ? form.requestSubmit() : form.submit());
  }
});